import { getKnowledgeSourceByPublicId } from "@/helpers/apis";
import { RelativeComponentLoader } from "@/components/loader";
import { Typography, Alert, AlertTitle, AlertDescription } from "@altimateai/lego";
import { useQuery } from '@tanstack/react-query';
import { useParams } from "react-router-dom";

const KnowledgeCatalogPublicDetails = () => {
  const { id } = useParams<{ id: string }>();
  const {
    data: knowledgeSource,
    isLoading: isKnowledgeSourceLoading,
    error: knowledgeSourceError,
  } = useQuery({
    queryKey: ["knowledgeSource", id],
    queryFn: () => getKnowledgeSourceByPublicId(id!),
    enabled: !!id,
  });

  const firstPageContent = knowledgeSource?.content?.pages?.[0]?.content ?? "";
  return (
    <div className="al-h-full al-overflow-y-auto al-p-4">
      {isKnowledgeSourceLoading ? (
        <RelativeComponentLoader label="Loading..." />
      ) : knowledgeSourceError && !!id ? (
        <Alert variant="destructive">
          <AlertTitle>Failed to load knowledge source</AlertTitle>
          <AlertDescription>
            {(knowledgeSourceError as Error)?.message ||
              "There was an error loading the knowledge source. Please try again later."}
          </AlertDescription>
        </Alert>
      ) : (
        <article>
          <Typography variant="h3" role="heading">
            {knowledgeSource?.name}
          </Typography>
          <Typography variant="body" role="description" className="al-text-gray-500">
            {knowledgeSource?.description}
          </Typography>
          <pre className="al-whitespace-pre-wrap al-break-words al-mt-4">
            <code style={{ fontFamily: '"Lexend", normal' }}>{firstPageContent}</code>
          </pre>
        </article>
      )}
    </div>
  );
};

export default KnowledgeCatalogPublicDetails;
